module.exports = __webpack_public_path__ + "static/il-invoice-9a0289679b6cbd7f05dcd62f71092a84.svg";